module.exports = __webpack_public_path__ + "static/media/flexi.c9ed754b.jpg";